import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 px-6 d-block d-md-none",
  id: "kt_footer"
}
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "text-muted-darker fw-bold me-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://valored.it",
    class: "footer-link"
  }, "VALORE D")
], -1)
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "me-5" }, "C.F. 97521290151", -1)
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "d-flex mt-3" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "© Copyright " + _toDisplayString(_ctx.currentYear) + " - ", 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("span", null, [
        _createElementVNode("a", {
          href: "#",
          class: "footer-link",
          role: "link",
          "aria-haspopup": "dialog",
          "aria-controls": "openPrivacyPolicy",
          "aria-label": _ctx.translate('PRIVACY_POLICY_LABEL'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)))
        }, _toDisplayString(_ctx.translate("PRIVACY_POLICY_LABEL")), 9, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("a", {
        href: "#",
        class: "footer-link me-8",
        role: "link",
        "aria-haspopup": "dialog",
        "aria-controls": "openCookiePolicy",
        "aria-label": _ctx.translate('COOKIE_POLICY_LABEL'),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCookiePolicy && _ctx.openCookiePolicy(...args)))
      }, _toDisplayString(_ctx.translate("COOKIE_POLICY_LABEL")), 9, _hoisted_9),
      _createElementVNode("a", {
        href: "#",
        class: "iubenda-cs-preferences-link footer-link",
        role: "link",
        "aria-haspopup": "dialog",
        "aria-controls": "openCookiePreferences",
        "aria-label": _ctx.translate('PREFERENCE_COOKIE_LABEL'),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCookiePreferences && _ctx.openCookiePreferences(...args)))
      }, _toDisplayString(_ctx.translate("PREFERENCE_COOKIE_LABEL")), 9, _hoisted_10)
    ])
  ]))
}